import { setComponentMapOverrides } from '@jutro/uiconfig';
import 'gw-capability-policychange-common-react';
import PolicyChangesPage from './pages/PolicyChanges/PolicyChangesPage';
import AddressPage from './pages/Address/AddressPage';
import ItemDetailsPage from './pages/ItemDetails/ItemDetailsPage';
import ItemInfoPage from './pages/ItemInfo/ItemInfoPage';
import RiskAnalysisPage from './pages/RiskAnalysis/RiskAnalysisPage';
import CoveragesPage from './pages/Coverages/CoveragesPage';
import PCHOQuotePage from './pages/Quote/QuotePage';
import './HOPolicyChange.messages';


setComponentMapOverrides(
    {
        PolicyChangesPage: { component: 'PolicyChangesPage' },
        AddressPage: { component: 'AddressPage' },
        ItemDetailsPage: { component: 'ItemDetailsPage' },
        ItemInfoPage: { component: 'ItemInfoPage' },
        RiskAnalysisPage: { component: 'RiskAnalysisPage' },
        CoveragesPage: { component: 'CoveragesPage' },
        PCHOQuotePage: { component: 'PCHOQuotePage' }
    },
    {
        PolicyChangesPage,
        AddressPage,
        ItemDetailsPage,
        ItemInfoPage,
        RiskAnalysisPage,
        CoveragesPage,
        PCHOQuotePage
    }
);
// eslint-disable-next-line import/prefer-default-export
export { default as HOPolicyChangeWizard } from './HOPolicyChangeWizard';
export { default as PackageInfoComponent} from './components/PackageInfo/PackageInfoComponent';
export {default as AdditionalInsuredInterestComponent} from './components/AdditionalInsuredInterest/AdditionalInsuredInterestComponent';